module.exports = __webpack_public_path__ + "static/learningRight-390c170b3466fdd4badfeb75c23f2ea8.svg";